exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ghost_header{\n    width: 25%;\n    height: 30px !important;\n}\n.ghost-content1{\n    width: 35%;\n    height: 12px !important;\n}\n\n.ghost-content2{\n    width: 100%;\n    height: 12px !important;\n}\n\n.ghost-content3{\n    width: 15%;\n    height: 12px !important;\n}\n.ghost-content4{\n    width: 60%;\n    height: 12px !important;\n}\n.ghost-content5{\n    width: 70%;\n    height: 12px !important;\n}\n\n.ghost-image{\n    margin-top: 10%;\n    margin-bottom: 10%;\n}\n\n.ghost-image-content{\n    width: 50%;\n    height: 200px !important;\n}\n.ghost-button{\n    width: 35%;\n    height: 45px !important;\n}\n\n.ghost-e-header{\n    width: 50%;\n    height: 30px !important;\n}\n.ghost-e-image{\n    margin-top: 6%;\n    margin-bottom: 5%;\n}\n.ghost-e-button{\n    width: 18%;\n    height: 45px !important;\n}\n.ghost-image-e-content{\n    width: 30%;\n    height: 200px !important;\n}\n.ghost-e-content1{\n    width: 25%;\n    height: 12px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-ghost-card-module/scora-ghost-card-module.component.css
// module id = 840
// module chunks = 6